// Models.
import Track from '../models/track'
import Media from '../models/media'
import Peer from '../Peer'

// Managers.
import MediaManager from '../managers/mediaManager'
import PeerManager from '../managers/peerManager'
import SessionManager from '../managers/sessionManager'
import DeviceManager from '../managers/deviceManager'
import TrackManager from '../managers/trackManager'
import WebRTCManager from '../managers/webrtcManager'
import Renderer from '../managers/renderer'

import { logManager } from '../logs'

// SDP helpers.
import sdpPipeline from '../sdpUtils/pipeline'
import * as sdpHandlers from '../sdpUtils/handlers'

// Utils
import { getBrowserDetails } from '../utils'

/**
 * @returns An dictionary of features that are supported on this platform.
 */
export function getWebRTCSupportCapabilities () {
  return {
    mediaDevices: Boolean(navigator.mediaDevices),
    peerConnection: Boolean(window.RTCPeerConnection)
  }
}

export default function initialize () {
  const log = logManager.getLogger('WebRTC')

  const browserDetails = getBrowserDetails()
  if (browserDetails.version) {
    log.debug(`Browser details: ${browserDetails.browser}, version ${browserDetails.version}.`)
  } else {
    log.debug('Browser details: Not supported by webRTC adapter.')
  }

  const renderer = new Renderer()
  const deviceManager = new DeviceManager()
  const trackManager = new TrackManager()
  const mediaManager = new MediaManager({ trackManager })
  const peerManager = new PeerManager({ trackManager })
  const sessionManager = new SessionManager({
    peerManager,
    mediaManager,
    trackManager
  })
  const webrtcManager = new WebRTCManager()

  return {
    models: {
      Track,
      Media,
      Peer
    },
    // TODO: Make naming consistent.
    managers: {
      devices: deviceManager,
      media: mediaManager,
      peerManager: peerManager,
      sessionManager,
      track: trackManager,
      // Give access to the Log Manager.
      // TODO: Don't include it under managers. It's here now because of
      //    ProxyStack annoyingness.
      logs: logManager,
      webrtcManager,
      renderer
    },
    sdp: {
      pipeline: sdpPipeline,
      handlers: sdpHandlers
    },
    // Export this on the webRTC stack for backwards compatibility.
    getBrowserDetails
  }
}
